import styled, { css } from "styled-components"
import { SvgIcon } from '@material-ui/core';

export const SvgIconStyled = styled(SvgIcon)`
  ${({ size }) => css`
    font-size: ${size || 12}px;
  `}
`
